import { GetStaticPaths, GetStaticProps } from "next";

import { PLASMIC } from "@abnormal/plasmic-init";
import { PreviewContent } from "@interfaces/PreviewContent.interface";
import BlogLayout from "@layouts/BlogLayout";
import { PER_PAGE } from "@lib/blog";
import fetchForm from "@lib/fetchForm";
import { returnStaticProps } from "@lib/returnStaticProps";
import craft from "@pages/api/craft";
import {
  PlasmicComponent,
  PlasmicRootProvider,
  extractPlasmicQueryData
} from "@plasmicapp/loader-nextjs";
import QueryBlogCategory from "@queries/blog/QueryBlogCategory.graphql";
import QueryCategorySlugs from "@queries/QueryCategorySlugs.graphql";

export const getStaticPaths: GetStaticPaths = async (context) => {
	// Fetch every possible path
	const response = await craft(QueryCategorySlugs, {
		group: "blogCategories",
		limit: 1,
	});

	const paths = [];

	response.categories.map((category) =>
		paths.push({
			params: { categorySlug: category.slug },
		})
	);

	return { paths, fallback: "blocking" };
};

export const getStaticProps: GetStaticProps = async ({
	params,
	previewData: nextPreviewData,
	preview,
}) => {
	// For Craft preview capability
	const previewData: PreviewContent = nextPreviewData as PreviewContent;

	// Construct uri from the slug array
	const { categorySlug } = params;

	// What is the uri
  const uri = `/blog/category/${categorySlug}`;
  
  const plasmicData = await PLASMIC.maybeFetchComponentData([
    "BladesDynamicDemoBlade",
    "Footer"
  ], {
    // deferChunks: true,
  });
  if (!plasmicData) {
    throw new Error("No Plasmic design found");
  }

	// Fetch the page's data
	const response = await craft(QueryBlogCategory, {
		categorySlug,
		limit: PER_PAGE,
	});

	const {
		pageEntry,
		category,
		posts,
		postCount,
		blogCategories,
		primaryNavigation,
		primaryCallToActions,
		persistentNav,
  } = response;
  
  // Cache the necessary Plasmic data fetched for the page
  const queryCache = await extractPlasmicQueryData(
    <PlasmicRootProvider loader={PLASMIC} prefetchedData={plasmicData}>
      <PlasmicComponent
        component="BladesDynamicDemoBlade"
      />
    </PlasmicRootProvider>
  );

	/*
		Fetch the form and pass form data as props
	*/
	let formData = null;

	// Use the form id specified by the selected form in the pageEntry (if there is one)
	const formId = pageEntry.form
		? pageEntry.form[0].formDetails[0].formId
		: null;

	if (formId) {
		formData = await fetchForm({ formId: formId });
	}

	// Return props if entry exists, otherwise check Retour for redirects or 404
	const returnResponse = await returnStaticProps(
		{
			navigation: {
				primaryNavigation,
				primaryCallToActions,
			},
			pageEntry,
			persistentNav,
			category,
			posts,
			blogCategories,
			formData,
			pageCount: Math.ceil(postCount / PER_PAGE),
      pageNumber: 1,
      plasmicData,
      queryCache
		},
		!category,
		uri
	);

	return returnResponse;
};

interface IProps {
	pageEntry: any;
	category: any;
	posts: any[];
  blogCategories: any[];
}

const Page = ({
	pageEntry,
	category,
	posts,
  blogCategories,
}: IProps): JSX.Element => {
	return <></>;
};

Page.Layout = BlogLayout;

export default Page;
